import { Stack, Typography } from '@mui/material'

export type ClimateSectionTitleProps = {
  title: string
  subtitle?: string
}

const ClimateSectionTitle = ({ title, subtitle }: ClimateSectionTitleProps) => {
  return (
    <Stack spacing={0.25}>
      <Typography variant="subtitle1" fontWeight={800}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Stack>
  )
}

export default ClimateSectionTitle
